module.exports = __webpack_public_path__ + "media/fonts/TTCommons-DemiBold-31f567a35734838e4a3b8bb86920f147.svg";